import React, { useEffect, useState } from 'react';
import FullPageLoader from '../FullPageLoader/FullPageLoader';
import { styled } from '@mui/system';
import { useLocation } from "react-router-dom";
import { auth, db } from '../../firebase';
import NavBar from './NavBar';
import { onAuthStateChanged } from 'firebase/auth';
import { getUserData, getUserDetails, getCollegeName } from '../HomePage/userManagement';
import DetailsDashboard from './DetailsDashboard';
import { ref, get, onValue, off } from 'firebase/database';
import DashboardWelcome from './DashboardWelcome';

const MainContainer = styled('div')({
    height: "100vh",
    display: 'flex',
    width: '100%',
    borderRadius: '16px',
});

const FirstHalf = styled('div')({
    width: '20%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRight: '2.5px solid #D8D0D0',
    borderBottom: '2.5px solid #D8D0D0',
    background: '#fafafa',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
});

const ContentHalf = styled('div')({
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
});

let dates = [];
const DashboardComponent = () => {
    const location = useLocation();
    const [isLoading, setIsLoading] = React.useState(true);
    const [user, setUser] = React.useState(null);
    const currentRoute = location.pathname;
    const [data, setData] = useState([]);
    const routePaths = [
        '/dashboard',
        '/userdetails',
        '/quetionairepart1',
        '/report',
    ];
    const activePageIndex = routePaths.indexOf(currentRoute);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
            if (authUser) {
                setUser(authUser);
                await getData(authUser.uid);
            } else {
                setUser(null);
            }
        });
        return () => {
            unsubscribe();
        };
    }, []);

    React.useEffect(() => {
        const loadingTimer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(loadingTimer);
    }, []);

    useEffect(() => {
        if (user && user.uid) {
            const userUid = user.uid;
            const dateRef = ref(db, `${getCollegeName()}/Assessments/${userUid}/Date Array`);

            const fetchUserData = () => {
                onValue(dateRef, (snapshot) => {
                    const dataFromDb = snapshot.val();
                    if (dataFromDb) {
                        const dataArray = Object.entries(dataFromDb).map(([timestamp, yo]) => ({
                            timestamp,
                            yo,
                        }));
                        setData(dataArray);
                    }
                });
            };

            fetchUserData();
            return () => {
                off(dateRef); // Remove listener on cleanup
            };
        }
    }, [user]);

    // Fetch user data
    const getData = async (userUid) => {
        if (userUid) {
            const dateRef = ref(db, `${getCollegeName()}/Assessments/${userUid}/Date Array`);
            const snapshot = await get(dateRef);
            dates = snapshot.val();
        }
    };

    // Get user name
    let name;
    if (getUserData) {
        name = getUserData.name;
    }

    return (
        <MainContainer>
            {isLoading && <FullPageLoader />}
            <FirstHalf>
                <NavBar activePage={activePageIndex} user={getUserDetails} />
            </FirstHalf>
            <ContentHalf>
                {dates ? <DetailsDashboard name={name} data={data} /> : <DashboardWelcome />}
            </ContentHalf>
        </MainContainer>
    );
};

export default DashboardComponent;
